import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)

import Button from 'primevue/button'
import Panel from 'primevue/panel'

import {AxiosStatic} from "axios";
import {inject, reactive, ref} from "vue";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import InputField from "@/components/blocks/InputField.vue";
import CompanyField from "@/components/blocks/CompanyField.vue";

// Define types
type FormData = {
  company: any | null
  name: string | null,
}

// Define component data

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateProjectForm',
  emits: ['itemCreated'],
  setup(__props, { emit: emits }) {

const formData = reactive<FormData>({
  company: null,
  name: null
})

const formRef = ref(null)
const submitted = ref<boolean>(false)

const rules = {
  company: {required},
  name: {required}
}

// Inject dependencies
const axios = inject<AxiosStatic>('axios')

// Define used properties
const router = useRouter()
const v$ = useVuelidate(rules, formData)

// Define emits


// Define functions
function handleSubmit(isFormValid: boolean) {
  submitted.value = true
  if (isFormValid) {
    saveProject()
  } else {
    console.error('Form is not valid!')
  }
}

function saveProject() {
  const path = "/project"

  axios?.post(path, buildData()).then((response) => {
    if (response.status >= 200 && response.status <= 299) {

      if (response.data.id > 0) {
        emits('itemCreated', response.data)
      } else {
        console.error("Can not save project. Invalid response", response)
      }


    } else {
      // message.error('Ulozeni spolecnosti se nezdarilo!')
      console.error(response)
    }
  })
}

function buildData(): any {
  return {
    name: formData.name,
    companyID: formData.company.id,
    companyName: formData.company.companyName
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Panel), {
    header: "Create Project",
    toggleable: true,
    collapsed: true,
    class: "mt-2"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"])),
        class: "p-fluid"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(CompanyField, {
              class: "col-2",
              id: "company",
              label: "Company",
              modelValue: formData.company,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.company) = $event)),
              vualidate: _unref(v$).company,
              submitted: submitted.value
            }, null, 8, ["modelValue", "vualidate", "submitted"]),
            _createVNode(InputField, {
              id: "name",
              class: "col-2",
              label: "Project name",
              vualidate: _unref(v$).name,
              submitted: submitted.value,
              modelValue: formData.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.name) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(Button), {
                type: "submit",
                label: "Create",
                class: "p-button-lg"
              })
            ])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})